import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useProjectMapContext } from './../../../hooks/useProjectMapContext';
import useItemsService from './../../../hooks/useItemsService';
import { HtmlElement } from '../../../../helpers/HtmlElements/HtmlElements';
import useFormHandler from './../../../hooks/useFormHandler'; // Assure-toi que le chemin d'importation est correct
import LayerSelector from './../../../helpers/LayerSelector';
import { debug } from '../../../../../utils';
const MarkerForm = ({ item = {} }) => {
  const project = useSelector((state) => state.project);
  const { setItemSelected, userCan } = useProjectMapContext();
  const { save_item, update_item } = useItemsService();
  const [itemCopy, handleChange] = useFormHandler(item); // Utilisation du hook useFormHandler

  useEffect(() => {
    if (itemCopy.itId !== item.itId) {
      handleChange(item); // Cette fonction devra être adaptée pour éviter les mises à jour si les objets sont identiques
    }

  }, [item, item.itId, handleChange]);


  const submit = async () => {
    let response = null;
    if (!itemCopy.itId || itemCopy.itId === '') {
      response = await save_item(itemCopy);
    } else {
      response = await update_item(itemCopy);
    }
    setItemSelected(null);
  };
  return (
    <div id="MarkerForm" className='pb-5'>
      <div className='mb-5'>
        <HtmlElement.formGroup
          value={itemCopy.itName || ''}
          name='itName'
          label='Nom :'
          onChange={handleChange}
          required={true}
          className='mb-3'
        />
        <HtmlElement.formGroup
          type='textarea'
          value={(itemCopy.meta && itemCopy.meta.description) || ''}
          name='meta.description'
          label='Description :'
          onChange={handleChange}
          required={true}
          className='mb-3'
          rows={6}
        />

        <LayerSelector
          selectedId={itemCopy.itParentId}
          name='itParentId'
          onChange={handleChange}
          required={true}
          allowCreate={true}
        />

      </div>
      {userCan('editItem') &&
        <HtmlElement.submit text="Sauvegarder" onClick={submit} />
      }

    </div>
  );
};

export default MarkerForm;
